"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "brallo-di-pregola": {
    "301e13b2": [{
      "hkey": "f6b84134",
      "slug": "colleri-collistano",
      "name": "Colleri-Collistano",
      "primary": true,
      "skipSearch": false
    }],
    "7eec7e93": [{
      "hkey": "d266887b",
      "slug": "brallo-di-pregola",
      "name": "Brallo di Pregola",
      "primary": true,
      "skipSearch": false
    }],
    "selva": [{
      "hkey": "d266887b",
      "slug": "brallo-di-pregola",
      "name": "Brallo di Pregola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "340b7bfd": [{
      "hkey": "48bbb257",
      "slug": "bralello-bocco",
      "name": "Bralello-Bocco",
      "primary": true,
      "skipSearch": false
    }],
    "bocco": [{
      "hkey": "48bbb257",
      "slug": "bralello-bocco",
      "name": "Bralello-Bocco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "brallo-di-pregola"
    }],
    "576f5184": [{
      "hkey": "48bbb257",
      "slug": "bralello-bocco",
      "name": "Bralello-Bocco",
      "primary": true,
      "skipSearch": false
    }],
    "bralello": [{
      "hkey": "48bbb257",
      "slug": "bralello-bocco",
      "name": "Bralello-Bocco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "530b77df": [{
      "hkey": "f6b84134",
      "slug": "colleri-collistano",
      "name": "Colleri-Collistano",
      "primary": true,
      "skipSearch": false
    }],
    "colleri": [{
      "hkey": "f6b84134",
      "slug": "colleri-collistano",
      "name": "Colleri-Collistano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "484e553d": [{
      "hkey": "f6b84134",
      "slug": "colleri-collistano",
      "name": "Colleri-Collistano",
      "primary": true,
      "skipSearch": false
    }],
    "colistano": [{
      "hkey": "f6b84134",
      "slug": "colleri-collistano",
      "name": "Colleri-Collistano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "brallo-di-pregola"
    }],
    "collistano": [{
      "hkey": "f6b84134",
      "slug": "colleri-collistano",
      "name": "Colleri-Collistano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "brallo-di-pregola"
    }],
    "56db575f": [{
      "hkey": "e7953a8f",
      "slug": "corbesassi-ponti",
      "name": "Corbesassi-Ponti",
      "primary": true,
      "skipSearch": false
    }],
    "corbesassi": [{
      "hkey": "e7953a8f",
      "slug": "corbesassi-ponti",
      "name": "Corbesassi-Ponti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "0d35a7b6": [{
      "hkey": "111c86b5",
      "slug": "lama-rovaiolo",
      "name": "Lama-Rovaiolo",
      "primary": true,
      "skipSearch": false
    }],
    "lama": [{
      "hkey": "111c86b5",
      "slug": "lama-rovaiolo",
      "name": "Lama-Rovaiolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "15738420": [{
      "hkey": "7e092850",
      "slug": "pietranatale-valle-superiore",
      "name": "Pietranatale-Valle Superiore",
      "primary": true,
      "skipSearch": false
    }],
    "pietranatale": [{
      "hkey": "7e092850",
      "slug": "pietranatale-valle-superiore",
      "name": "Pietranatale-Valle Superiore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "677cd5c0": [{
      "hkey": "e7953a8f",
      "slug": "corbesassi-ponti",
      "name": "Corbesassi-Ponti",
      "primary": true,
      "skipSearch": false
    }],
    "ponti": [{
      "hkey": "e7953a8f",
      "slug": "corbesassi-ponti",
      "name": "Corbesassi-Ponti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "brallo-di-pregola"
    }],
    "a7cdf5c0": [{
      "hkey": "111c86b5",
      "slug": "lama-rovaiolo",
      "name": "Lama-Rovaiolo",
      "primary": true,
      "skipSearch": false
    }],
    "rovaiolo": [{
      "hkey": "111c86b5",
      "slug": "lama-rovaiolo",
      "name": "Lama-Rovaiolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "brallo-di-pregola"
    }]
  }
};
exports["default"] = _default;